Whether a candidate profile exists.
